export { StudentCreateFormModal } from './student-create-form-modal';
